export default __webpack_public_path__ + "static/media/sequenceNotShared2.f41f951e.png";